import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  LegalEntityFormGroup,
  PersonAddressControls,
} from '@app/models/form.models';

export function getLegalEntitiyData(
  fb: FormBuilder,
): FormGroup<LegalEntityFormGroup> {
  return fb.nonNullable.group<LegalEntityFormGroup>({
    taxNumber: fb.nonNullable.control('', [Validators.required]),
    name: fb.nonNullable.control('', [Validators.required]),
    email: fb.nonNullable.control('', [Validators.required, Validators.email]),
    country: fb.nonNullable.control('', [Validators.required]),
    ownershipStructure: fb.control<number | null>(null),
    contactInfo: fb.nonNullable.control(''),
    website: fb.nonNullable.control(''),
    teaorNumbers: fb.control<string | null>(null),
    bankAccountNumber: fb.nonNullable.control(''),
    companyTypeId: fb.nonNullable.control(''),
    address: fb.nonNullable.group<PersonAddressControls>({
      countryCode: fb.nonNullable.control('', [Validators.required]),
      zipCode: fb.nonNullable.control('', [Validators.required]),
      city: fb.nonNullable.control('', [Validators.required]),
      publicSpace: fb.nonNullable.control('', [Validators.required]),
      publicSpaceType: fb.nonNullable.control('', [Validators.required]),
      houseNumber: fb.nonNullable.control('', [Validators.required]),
      doorOrFloor: fb.nonNullable.control(''),
    }),
  });
}
